export default __webpack_public_path__ + "static/media/js.7f3c55f6.svg";